const connectedEntitiesTypes = {
  BENEFICIAL_OWNERS: { id: 'BeneficialOwners', name: 'Beneficial owner' },
  BOARD_MEMBERS: { id: 'BoardMembers', name: 'Board members' },
};

export default connectedEntitiesTypes;
